import React, { useEffect, useState } from 'react';
import { Alert, Button } from 'antd';
import { MobileOutlined, DesktopOutlined } from '@ant-design/icons';
import config from 'config';
import { I18n } from 'helpers/i18n';

const Verification = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [redirectAttempted, setRedirectAttempted] = useState(false);

  useEffect(() => {
    document.title = `TECD - ${I18n.t('tecd_slogan')}`;
    // Detect mobile device
    const checkMobile = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const isMobileDevice = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
      setIsMobile(isMobileDevice);
    };

    checkMobile();

    // If mobile, attempt to redirect to tecd://verification
    if (isMobile && !redirectAttempted) {
      setRedirectAttempted(true);
      // Try to redirect to the app
      window.location.href = 'tecd://verification';
      
      // Fallback: if the app doesn't open, show a message after a delay
      setTimeout(() => {
        // This will only show if the redirect didn't work
        console.log('App redirect may have failed');
      }, 2000);
    }
  }, [isMobile, redirectAttempted]);

  const handleRetryRedirect = () => {
    if (isMobile) {
      window.location.href = 'tecd://verification';
    }
  };

  const getCurrentDomain = () => {
    return window.location.origin;
  };

  if (isMobile) {
    return (
      <div style={{ 
        padding: '20px', 
        textAlign: 'center', 
        minHeight: '50vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <MobileOutlined style={{ fontSize: '64px', color: '#1890ff', marginBottom: '20px' }} />
        <h2>{I18n.t('verification_redirecting')}</h2>
        <p style={{ marginBottom: '20px', color: '#666' }}>
          {I18n.t('verification_manual_redirect')}
        </p>
        <Button 
          type="primary" 
          size="large"
          onClick={handleRetryRedirect}
          style={{ marginBottom: '20px' }}
        >
          {I18n.t('verification_open_app')}
        </Button>
        <Alert
          message={I18n.t('verification_technical_info')}
          description={
            <div>
              <p><strong>{I18n.t('verification_domain')}:</strong> {getCurrentDomain()}</p>
              <p><strong>{I18n.t('verification_environment')}:</strong> {config.env}</p>
              <p><strong>{I18n.t('verification_deep_link')}:</strong> tecd://verification</p>
            </div>
          }
          type="info"
          style={{ maxWidth: '500px', textAlign: 'left' }}
        />
      </div>
    );
  }

  return (
    <div style={{ 
      padding: '20px', 
      textAlign: 'center', 
      minHeight: '50vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      <DesktopOutlined style={{ fontSize: '64px', color: '#ff4d4f', marginBottom: '20px' }} />
      <h2>{I18n.t('verification_desktop_title')}</h2>
      <p style={{ marginBottom: '20px', color: '#666' }}>
        {I18n.t('verification_desktop_message')}
      </p>
      <Alert
        message={I18n.t('verification_desktop_guide')}
        description={
          <div>
            <p>{I18n.t('verification_desktop_step1')}</p>
            <p>{I18n.t('verification_desktop_step2')}</p>
            <p>{I18n.t('verification_desktop_step3')}</p>
          </div>
        }
        type="warning"
        style={{ maxWidth: '500px', textAlign: 'left', marginBottom: '20px' }}
      />
      <Alert
        message={I18n.t('verification_technical_info')}
        description={
          <div>
            <p><strong>{I18n.t('verification_domain')}:</strong> {getCurrentDomain()}</p>
            <p><strong>{I18n.t('verification_environment')}:</strong> {config.env}</p>
            <p><strong>{I18n.t('verification_deep_link')}:</strong> tecd://verification</p>
          </div>
        }
        type="info"
        style={{ maxWidth: '500px', textAlign: 'left' }}
      />
    </div>
  );
};

export default Verification;
